export const REQUIRED_RULES = [
  {required: true, message: '这是必填项', trigger: 'blur,change', pattern: /^.*$/},
];
export const REQUIRED_RULES_CHANGE = [
  {required: true, message: '这是必填项', trigger: 'change,blur', pattern: /^.*$/},
];

export const REQUIRED_RULES_TRIGGER_CHANGE = [
  {required: true, message: '这是必填项', trigger: 'change,blur'},
];

export const PHONE_RULES = [
  {pattern: /^1[0-9]{10}$/, message: '请输入正确的手机号', trigger: 'blur,change'},
];
export const TEL_PHONE_RULES = [
  {pattern: /(^0\d{2,3}\-\d{7,8}$)|(^1[2|3|4|5|6|7|8][0-9]{9}$)/, message: '请输入正确的手机号/固定电话', trigger: 'blur,change'},
];

export const PHONE_RULES_REQUIRE = [
    {required: true, pattern: /^1[0-9]{10}$/, message: '请输入正确的手机号', trigger: 'blur,change'},
  ];

export const POSITIVE_INTEGER_RULES = [
  {
    pattern: /^[1-9]*[1-9][0-9]*$/,
    message: '请输入正确的自然数',
    trigger: 'blur',
  },
];

export const DATE_RULES = [
  {
    required: true,
    message: '请选择时间',
    trigger: 'change,blur',
    type: 'array',
  },
];

export const NUM_LETTER_RULES = [
  {
    required: true,
    message: '只允许输入数字和英文字母',
    trigger: 'blur,change',
    pattern: /^[0-9a-zA-Z]+$/,
  },
];
export const NUM_NOQUERY_RULES = [
  { pattern: /^[1-9]\d*$/, message: '只能输入正确的数字' ,trigger: 'blur,change',}
];
